import * as React from 'react';
import {ErrorAlert} from '../common/ErrorAlert';
import {Client, ErrorResponse, SaveClientResponse, User} from '../api/dtos/dtos';
import {RouteComponentProps, withRouter} from 'react-router';
import furoApi from '../api/FuroApi';
import * as paths from '../paths';
import ClientForm from './ClientForm';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {showSaveConfirm, showSaveSuccessNotification} from "../utils/dialogs";

interface CreateClientPageState {
  error?: ErrorResponse;
  users: User[];
}

class CreateClientPage extends React.Component<RouteComponentProps<{}>, CreateClientPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      users: [],
    };
  }

  public componentDidMount() {
    this.reload();
  }

  public render() {
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <ClientForm
          users={this.state.users.map(user => user.userName!)}
          editable={true}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
        />
        <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>
      </>
    );
  }

  private reload = () => {
    this.loadUsers();
  };

  private loadUsers = () => {
    const promise = furoApi.users.getUsers()
      .then(response => {
        this.setState({
          users: response,
          error: undefined,
        });
      })
      .catch((error: ErrorResponse) => {
        this.setState({error});
      });
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = (client: Client) => {
    showSaveConfirm(() => this.saveFormValues(client));
  };

  private saveFormValues = (client: Client) => {
    withLoadingOverlay(
      furoApi.clients.create(client)
        .then(this.onSaveClientSuccess)
        .catch(this.onApiError), this.loadingHandler);
  };

  private onSaveClientSuccess = (response: SaveClientResponse) => {
    showSaveSuccessNotification();
    this.props.history.replace(paths.viewClientPath(response.clientId));
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default withRouter(CreateClientPage);




// WEBPACK FOOTER //
// ./src/client-details/CreateClientPage.tsx